import { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import { QualityInformationILES } from "./QualityInformationILES/QualityInformationILES";
import { QualityReprocessingItem } from "./QualityReprocessing/QualityReprocessingItem/QualityReprocessingItem";
import { QualityInspectionOperation } from "./QualityProductionOrder/QualityInspectionOperation/QualityInspectionOperation";
import { QualityInspectionChangePartsItems } from "./QualityProductionOrder/QualityInspectionChangeParts/QualityInspectionChangePartsItems/QualityInspectionChangePartsItems";
import { QualityInspectionProduct } from "./QualityProductionOrder/QualityInspectionProduct/QualityInspectionProduct";
import { QualityInspectionProductRamdom } from "./QualityProductionOrder/QualityInspectionProductRamdom/QualityInspectionProductRamdom";
import { QualityInspectionItems } from "./QualityInspection/QualityInspectionItems/QualityInspectionItems";

export const QualityManager = () => {

    const [step, setStep] = useState<any>({});

    const [card, setCard] = useState<any[]>([
        { id: 1, name: `ILES`, descripcion: `Gestión y control de inspecciones en línea de ensamble (ILES).`, boton: 'Entrar' },
        { id: 2, name: `Reprocesos`, descripcion: `Registro y seguimiento de piezas o productos enviados a reproceso.`, boton: 'Entrar' },
        { id: 3, name: `Inspección Operaciones`, descripcion: `Verificación de calidad durante las distintas operaciones del proceso.`, boton: 'Entrar' },
        { id: 4, name: `Inspecciones de Requisitos Generales (Productos)`, descripcion: `Control del cumplimiento de los requisitos generales establecidos.`, boton: 'Entrar' },
        { id: 5, name: `Inspecciones Aleatorias`, descripcion: `Muestreo y control aleatorio de productos o procesos.`, boton: 'Entrar' },
        { id: 6, name: `Cambios de Pieza`, descripcion: `Registro y validación de cambios o sustituciones de piezas.`, boton: 'Entrar' },
        { id: 7, name: `Inspección de Calidad`, descripcion: `Registros de Inspecciones de calidad Realizadas`, boton: 'Entrar' },
    ]);


    useEffect(() => {
        setStep(
            { id: 0, name: '' }
        );
    }, [])


    return (
        <div className="row">
            <div className="col-12">
                <BasicPage titulo="Inspecciones">
                    <div className="row">
                        <div className="col">
                            {step.id > 0 &&
                                <>
                                    <div className="d-flex justify-content-around">
                                        <div>

                                            <h5> {step.name}</h5>

                                        </div>
                                        <div>
                                            <a href="javascript:void(0)" className="btn btn-primary btn-sm" onClick={() => { setStep({ id: 0 }) }}>Regresar</a>
                                        </div>
                                    </div>
                                    <hr />
                                </>

                            }
                        </div>
                    </div>
                    {step.id == 0 &&
                        <div className="row">
                            {card.map((item: any, index: number) => {
                                return (
                                    <div key={index} className="col-xxl-4 col-md-6">
                                        <div className="card card-body">
                                            <div className="flex-grow-1 ms-2">
                                                <h5>{item.name}</h5>
                                                <p>{item.descripcion}</p>
                                                <a href="javascript:void(0)" className="btn btn-primary btn-sm" onClick={() => { setStep(item) }}>{item.boton}</a>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    }

                    {step.id === 1 &&
                        <QualityInformationILES isModal notModify />
                    }

                    {step.id === 2 &&
                        <QualityReprocessingItem QualityReprocessing={{}} isReport />
                    }

                    {step.id === 3 &&
                        <QualityInspectionOperation _ProductionOrder={{}} isModal isReport />
                    }
                    {step.id === 4 &&
                        <QualityInspectionProduct _ProductionOrder={{}} isReport isModal />
                    }
                    {step.id === 5 &&
                        <QualityInspectionProductRamdom _ProductionOrder={{}} isModal isReport />
                    }
                    {step.id === 6 &&
                        <QualityInspectionChangePartsItems QualityInspectionChangeParts={{}} isReport />
                    }
                    {step.id === 7 &&
                        <QualityInspectionItems QualityInspection={{}} isReport />
                    }

                </BasicPage>
            </div>
        </div>
    )
}